<form [formGroup]="formGroup" (change)=saveForm()>
  <snelstart-ui-number-form-control [decimals]="0"
                                    label="Buitenlandse winst uit ondernemingen"
                                    align="right"
                                    class="custom-input-250"
                                    formControlName="winstUitOndernemingBuitenland"
                                    id="winstUitOndernemingBuitenland"
                                    prefix="€">
  </snelstart-ui-number-form-control>
  <snelstart-ui-number-form-control [decimals]="0"
                                    label="Buitenlandse loon tegenwoordig"
                                    align="right"
                                    class="custom-input-250"
                                    formControlName="loonTegenwoordigeDienstbetrekkingBuitenland"
                                    id="loonTegenwoordigeDienstbetrekkingBuitenland"
                                    prefix="€">
  </snelstart-ui-number-form-control>
  <snelstart-ui-number-form-control [decimals]="0"
                                    label="Buitenlandse loon vroeger"
                                    align="right"
                                    class="custom-input-250"
                                    formControlName="pensioenEnAndereUitkeringenBuitenland"
                                    id="pensioenEnAndereUitkeringenBuitenland"
                                    prefix="€">
  </snelstart-ui-number-form-control>
  <snelstart-ui-number-form-control [decimals]="0"
                                    label="Overige buitenlandse inkomsten"
                                    align="right"
                                    class="custom-input-250"
                                    formControlName="overigeInkomstenBuitenland"
                                    id="overigeInkomstenBuitenland"
                                    prefix="€">
  </snelstart-ui-number-form-control>
  <snelstart-ui-number-form-control [decimals]="0"
                                    label="Buitenlandse aftrek lijfrente"
                                    align="right"
                                    class="custom-input-250"
                                    formControlName="uitgavenVoorInkomensvoorzieningBuitenland"
                                    id="uitgavenVoorInkomensvoorzieningBuitenland"
                                    prefix="€">
  </snelstart-ui-number-form-control>
  <snelstart-ui-number-form-control [decimals]="0"
                                    label="Buitenlandse aftrek eigen woning"
                                    align="right"
                                    class="custom-input-250"
                                    formControlName="aandeelSaldoEigenWoningBuitenland"
                                    id="aandeelSaldoEigenWoningBuitenland"
                                    prefix="€">
  </snelstart-ui-number-form-control>
  <snelstart-ui-number-form-control [decimals]="0"
                                    label="Buitenlandse voordeel box 2"
                                    align="right"
                                    class="custom-input-250"
                                    formControlName="voordeelAanmerkelijkBelangBuitenland"
                                    id="voordeelAanmerkelijkBelangBuitenland"
                                    prefix="€">
  </snelstart-ui-number-form-control>
  <snelstart-ui-number-form-control [decimals]="0"
                                    label="Buitenlandse voordeel box 3"
                                    align="right"
                                    class="custom-input-250"
                                    formControlName="voordeelSparenEnBeleggenBuitenland"
                                    id="voordeelSparenEnBeleggenBuitenland"
                                    prefix="€">
  </snelstart-ui-number-form-control>
  <snelstart-ui-number-form-control [decimals]="0"
                                    label="Buitenlandse grondslag box 3"
                                    align="right"
                                    class="custom-input-250"
                                    formControlName="grondslagSparenEnBeleggenBuitenland"
                                    id="grondslagSparenEnBeleggenBuitenland"
                                    prefix="€">
  </snelstart-ui-number-form-control>
</form>
